var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChevronRightBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.79289 18.7071C9.40237 18.3166 9.40237 17.6834 9.79289 17.2929L15.0858 12L9.79289 6.70711C9.40237 6.31658 9.40237 5.68342 9.79289 5.29289C10.1834 4.90237 10.8166 4.90237 11.2071 5.29289L17.2071 11.2929C17.5976 11.6834 17.5976 12.3166 17.2071 12.7071L11.2071 18.7071C10.8166 19.0976 10.1834 19.0976 9.79289 18.7071Z",
    fill: "#1226AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronRightBlue);
export default __webpack_public_path__ + "static/media/icon_chevron-right-blue.1fb3e442eaaca30f99716964cb999fbd.svg";
export { ForwardRef as ReactComponent };